import { HttpApiError, HttpApiMiddleware } from "@effect/platform";
import { Context } from "effect";

/** Parsed JSON payload from a Postmark inbound webhook request. */
export class PostmarkPayload extends Context.Tag("PostmarkPayload")<
  PostmarkPayload,
  unknown
>() {}

/** Logs invalid Postmark Basic auth credentials while providing PostmarkPayload. */
export class PostmarkVerification extends HttpApiMiddleware.Tag<PostmarkVerification>()(
  "PostmarkVerification",
  { failure: HttpApiError.Unauthorized, provides: PostmarkPayload },
) {}
